import { render, staticRenderFns } from "./DiscountEffects.vue?vue&type=template&id=2f95b86a&scoped=true&"
import script from "./DiscountEffects.vue?vue&type=script&lang=js&"
export * from "./DiscountEffects.vue?vue&type=script&lang=js&"
import style0 from "./DiscountEffects.vue?vue&type=style&index=0&id=2f95b86a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95b86a",
  null
  
)

export default component.exports